module.exports = "<div class=page-title> <h4 style=font-family:sharp600> <i class=\"fa {{ $ctrl.icon }}\"></i> {{ $ctrl.title }} </h4> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/page-title/page-title.html
// module id = 356
// module chunks = 0